<template>
   <validation-observer ref="TicketForm">
        <b-form class="formBox">
            <validation-provider :name="$t('ticket.form.title')" :rules="{ required: true, min: 6 }" v-slot="validationContext">
                <b-form-group class="inputGrp" :label="$t('ticket.form.title')" label-for="subjectTitle">
                    <b-form-input
                        subcejtTitle_id="subjectTitle"
                        v-model="title"
                        :state="getValidationState(validationContext)"
                        aria-describedby="live-feedback"
                    ></b-form-input>
                    <b-form-invalid-feedback subcejtTitle_id="live-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                </b-form-group>
            </validation-provider>
            <validation-provider :name="$t('ticket.form.client')" :rules="{ required: true, is_not: null }" v-slot="validationContext">
                <b-form-group class="inputGrp" :label="$t('ticket.form.client')"  label-for="customer_id">
                    <div class="elements">
                        <Multiselect
                            @input='resetAll'
                            customer_id="customer_id"
                            v-model="customer"
                            :show-labels="false" 
                            :options="customersList" 
                            :multiple="false" 
                            label="name" 
                            track-by="ID" 
                            :searchable="true" 
                            :state="getValidationState(validationContext)"
                            @search-change="searchCustomer" >
                                <template slot="singleLabel" slot-scope="props">
                                    <strong>{{props.option.name }}</strong> 
                                </template>
                        </Multiselect>
                    </div>
                    <b-form-invalid-feedback customer_id="live-feedback" style="display:block">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                </b-form-group>
            </validation-provider>

            <span>
                <b-form-group class="inputGrp" :label="$t('ticket.form.supportType')" label-for="type">
                    <b-form-radio-group
                        id="type"
                        v-model="ticketType"
                        @input="resetAll"
                        :options="types"
                        aria-describedby="live-feedback"></b-form-radio-group>
                </b-form-group>
            </span>
            <validation-provider v-if="customer && ticketType == 1" name="Abonelik" :rules="{ required: ticketType == 1, is_not: null }" v-slot="validationContext">
                <b-form-group class="inputGrp" :label="$t('ticket.form.subs')"  label-for="subs">
                    <div class="elements">
                            <Multiselect  
                            @input="checkSubscription"
                            v-model="customer_sub"
                            :show-labels="false" 
                            :options="customerSubs"
                            :custom-label="subName"
                            :state="getValidationState(validationContext)"
                            aria-describedby="live-feedback"
                            label="name"
                            track-by="id">
                                <template slot="singleLabel" slot-scope="{ option }">
                                    <strong>{{ option.sub && option.sub.name }} </strong> 
                                </template>
                        </Multiselect>
                    </div>
                    <b-form-invalid-feedback customer_id="live-feedback" style="display:block">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                </b-form-group>
            </validation-provider>

            <validation-provider v-if="customer && ticketType == 2" name="Müşteri Ürünü" :rules="{ required: true, is_not: null }" v-slot="validationContext">
                <b-form-group class="inputGrp" label="Müşteri Ürünü"  label-for="customerp_id">
                    <div class="elements">
                        <Multiselect  
                            @input='resetAll'
                            customer_id="customerp_id"
                            v-model="customerProduct"
                            :show-labels="false"
                            :custom-label="productName"
                            :options="customerProducts"
                            :state="getValidationState(validationContext)"
                            :loading="isCustomerProductsLoading"
                            aria-describedby="live-feedback"
                            label="name"
                            track-by="id">
                                <template slot="singleLabel" slot-scope="{ option }">
                                    <strong>{{ option.product.name }} </strong> 
                                </template>
                        </Multiselect>
                    </div>
                    <b-form-invalid-feedback customer_id="live-feedback" style="display:block">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                </b-form-group>
            </validation-provider>

            <div style="width:100%;margin-top:1rem;">
                <validation-provider :name="$t('ticket.form.comment')" :rules="{ required: true }" v-slot="validationContext">
                    <b-form-group class="editor" :label="$t('ticket.form.comment')" label-for="ticketInfo">
                        <b-form-textarea
                            rows="10"
                            ticket_id="ticketInfo"
                            v-model="ticketInfo.comment"
                            :state="getValidationState(validationContext)"
                            aria-describedby="live-feedback"
                        ></b-form-textarea>
                        <b-form-invalid-feedback device_id="live-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
                </validation-provider>
            </div>

            <div class="footerButtons">
                <b-button variant="primary" @click="$emit('save')">{{$t("ticket.save")}}</b-button>
            </div>
        </b-form>
        <Modals :open="modalOpen" :modalEvent="openModal" :modalProps="modalProps" :form="currentForm" :modalName="modalName" />
    </validation-observer>
</template>
<script>

import Multiselect from 'vue-multiselect'
// import { VueEditor } from "vue2-editor";
import i18n from '@/plugins/i18n'
import Modals from "../modals/";
import moment from 'moment'

  export default {
    data() {
      return {
        title: '',
        params:{
            limit:25,
            offset: 0,
        },
        ticketInfo: {
            comment: ''
        },
        serialNumber: '',
        customer: null,
        product: null,
        customerProduct: null,
        status: 1,
        customer_sub: null,
        expired: false,
        modalOpen: false,
        modalProps: {},
        currentForm:"Ticket",
        modalName: '',
        types: [
            { text: i18n.t('ticket.form.subscription'), value: 1 },
            { text: i18n.t('ticket.form.product'), value: 2 },
        ],
        ticketType: 0,
        isCustomerProductsLoading: false
      }
    },
    watch: {
        async customer(val) {
            this.isCustomerProductsLoading = true
            await this.$store.dispatch('fetchCustomerProducts', val.ID)
            this.isCustomerProductsLoading = false
        }
    },
    computed: {
        customerSubs() {
            return this.customer.customer_subs ? this.customer.customer_subs : []
        },
        customerProducts() {
            return this.$store.getters.customerProducts
        },
        customersList() {
            return this.$store.getters.customerList
        }
    },
    methods:{
        resetCustomer() {
            this.customer_sub = null
        },
        openModal(state, modal, props) {
            this.modalOpen = state
            if(state){
                this.modalProps = props
                this.modalName = modal
            }
        },
        searchCustomer(s){
            this.params['name'] = s
            this.$store.dispatch('customer_get', this.params)
        },
        resetProduct() {
            this.product = null
            this.serialNumber = ''
        },
        resetAll() {
            this.resetCustomer()
            this.resetProduct()
        },
        checkSubscription(item){
                 if(moment().isAfter(item.end_date)){
                    this.openModal(true, 'expired', item)
                    this.expired = true
                 }
        },
        subName({sub}) {
            return sub && sub.name
        },
        productName({product}) {
            return product && product.name
        },
        getValidationState({ dirty, validated, valid = null }) {
            return dirty || validated ? valid : null;
        },
    },
    components:{
        Multiselect, Modals
    },
    created(){
        this.$store.dispatch('customer_get', this.params)
    }
  }
</script>
<style lang="css" scoped > 
    @import "../styles/add.min.css"; 
</style>


// WEBPACK FOOTER //
// src/pages/Support/Ticket/components/TicketForm.vue